var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.6875C0 1.96143 1.37825 0.5625 3.07882 0.5625H18.4729C20.1711 0.5625 21.5517 1.96143 21.5517 3.6875V19.3125C21.5517 21.0361 20.1711 22.4375 18.4729 22.4375H3.07882C1.37825 22.4375 0 21.0361 0 19.3125V3.6875ZM2.30911 3.6875V19.3125C2.30911 19.7422 2.65356 20.0938 3.07882 20.0938H18.4729C18.8962 20.0938 19.2426 19.7422 19.2426 19.3125V3.6875C19.2426 3.25586 18.8962 2.90625 18.4729 2.90625H3.07882C2.65356 2.90625 2.30911 3.25586 2.30911 3.6875Z",
    fill: "white",
    fillOpacity: 0.27
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.b52563337a12182c432cced69c0b27f4.svg";
export { ForwardRef as ReactComponent };